import { Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';

import { LoaderService } from './services/loader-service';

interface IAreas {
    Text: string,
    Value: string
}

const PARENT_SELECTOR = '.loading';
const ACTIVATE_SELECTOR = 'loaded-show';

@Component({
    selector: 'app-al-tarifs',
    template: require('./app.component.al-tarifs.html'),
    styles: [require('./app.component.repres-stores-request.css')],
    providers: [ApiDataService, LoaderService]
})
export class AlTarifsComponent implements OnInit {

    private culture: string = 'uk';
    private init: IApiResultObject = null;
    private areasList: IAreas[] = [];
    private selectedValue: string | null = null;

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef,
        private loader: LoaderService) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        translate.setDefaultLang(this.culture);

        this.init = {} as IApiResultObject;
        this.init.data = [];
    }

    ngOnInit() {
        
    }

    GetAreas(city: string): void {
        this.areasList = [];

        this.loader.ajaxLoaderStart(PARENT_SELECTOR, ACTIVATE_SELECTOR);
        this.apiDataService.Get(`/${this.culture}/Home/GetAreasDetails?city=${city}`)
            .subscribe(d => {
                this.loader.ajaxLoaderEnd(PARENT_SELECTOR, ACTIVATE_SELECTOR);
                this.init = d as IApiResultObject;
                if (this.init.status) {
                    this.areasList = this.init.data;
                }
                else
                    alert(this.init.message);
            });
    }

    displayArea(areaValue: string): string {
        const area = this.areasList.find(a => a.Value === areaValue);
        return area ? area.Text : '';
    }

    GetTarifs(event: any): void {
        this.selectedValue = event.option.value;

        this.loader.ajaxLoaderStart(PARENT_SELECTOR, ACTIVATE_SELECTOR);
        const url = `/${this.culture}/Home/GetAuxPickupDeliveryNumbers?id=${this.selectedValue}`;
        this.apiDataService.GetPartial(url)
            .subscribe(content => {
                this.loader.ajaxLoaderEnd(PARENT_SELECTOR, ACTIVATE_SELECTOR);
                if (content) {
                    const tarifsContent = document.getElementById('tarifs_content');
                    if (tarifsContent) {
                        tarifsContent.innerHTML = content;
                    }
                }
            },
            (error) => {
                console.error('Ошибка при получении HTML:', error);
            });
    }

    onInputChange(event: Event): void {
        const input = (event.target as HTMLInputElement).value.toLowerCase();
        this.GetAreas(input);
    }
}